import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminPlatformAdmin = () => (
  <AdminServiceTickets
    serviceCode="admin"
    title="Administration"
    lead="Les demandes liées aux obligations fiscales et sociales des clients."
  />
);

export default AdminPlatformAdmin;
